export const formatBreakdownParams = (breakdown) => {
  if (breakdown === 'none') {
    return '';
  }
  if (Array.isArray(breakdown)) {
    return breakdown.join(',');
  }
  return breakdown;
};
